// Parses and normalizes version text
const parseVersion = (versionText) => {
  return (versionText || "")
    .split(".")
    .map((part) => (isNaN(part) ? part : Number(part)));
};

// Compares two policy versionText strings
export const versionComparator = (a, b) => {
  const pa = parseVersion(a.versionText);
  const pb = parseVersion(b.versionText);

  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    if (pa[i] === undefined) return -1;
    if (pb[i] === undefined) return 1;
    if (pa[i] < pb[i]) return -1;
    if (pa[i] > pb[i]) return 1;
  }
  return 0;
};

// Takes raw policy list, returns list with isHighestVersion flag added
export const markHighestVersionPolicies = (policies) => {
  // Step 1: Build a lookup of highest versions per policyNumber
  const grouped = policies.reduce((acc, row) => {
    const key = row.policyNumber;
    if (!acc[key]) acc[key] = [];
    acc[key].push(row);
    return acc;
  }, {});

  const highestVersionMap = {};
  Object.entries(grouped).forEach(([policyNumber, rows]) => {
    const sorted = [...rows].sort(versionComparator);
    const highest = sorted[sorted.length - 1];
    highestVersionMap[policyNumber] = highest.versionText;
  });

  // Step 2: Map original array, adding isHighestVersion based on the lookup
  return policies.map((row) => ({
    ...row,
    isHighestVersion: row.versionText === highestVersionMap[row.policyNumber],
  }));
};

export const getPolicyVersions = (policyNumber, allPolicies) => {
  const versions = allPolicies
    .filter((p) => p.policyNumber === policyNumber)
    .sort(versionComparator)
    .reverse(); // Optional: latest version first
  return versions;
};
